import { render, staticRenderFns } from "./RelatorioContrato.vue?vue&type=template&id=f0e6b128&scoped=true&"
import script from "./RelatorioContrato.vue?vue&type=script&lang=js&"
export * from "./RelatorioContrato.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioContrato.vue?vue&type=style&index=0&id=f0e6b128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e6b128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VDivider,VForm})
